<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="800px"
    >
      <div class="dialog-content lg">
        <el-form ref="form" :rules="rules" :model="form" label-width="120px" style="width: 100%; margin: auto; padding: 30px 0;">

          <el-row>
            <el-col :span="12">
              <el-form-item label="产品名称" prop="cpmc">
                  <el-input v-model="form.cpmc" clearable  placeholder="请输入" show-word-limit  />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品图标" prop="images">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="uploadedFiles">
                  <img v-if="form.images" :src="baseUrl+form.images" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="贷款额度(万元)" prop="dkedxx">
                <el-input-number el-input-number controls-position="right"  v-model="form.dkedxx" clearable placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="" prop="dkedsx" >
                <el-input-number el-input-number controls-position="right"  v-model="form.dkedsx"   clearable placeholder="请输入"></el-input-number>
            </el-form-item>
            </el-col>
          </el-row> -->
          <el-form-item label="贷款额度(万元)" prop="dkedsx">
            <el-input-number el-input-number controls-position="right"  v-model="form.dkedxx" style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
            <span style="margin: 0 15px;">~</span>
            <el-input-number el-input-number controls-position="right"  v-model="form.dkedsx" style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
          </el-form-item>

          <el-form-item label="利率范围(%)" prop="zgnhlv">
            <el-input-number el-input-number controls-position="right"   v-model="form.zdnhlv" style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
            <span style="margin: 0 15px;">~</span>
            <el-input-number el-input-number controls-position="right"   v-model="form.zgnhlv" style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
          </el-form-item>

          <el-form-item label="贷款期限(月)" prop="dkqxsx">
            <el-input-number el-input-number controls-position="right"   v-model="form.dkqxxx"  style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
            <span style="margin: 0 15px;">~</span>
            <el-input-number el-input-number controls-position="right"   v-model="form.dkqxsx" style="width: 45%;"  clearable placeholder="请输入"></el-input-number>
          </el-form-item>

          <el-row>
            <el-col :span="12">
              <el-form-item label="担保方式" prop="dbfsc">
                <select-from-dictionary
                  :code="'guaranty'"
                  :placeholder="'担保方式'"
                  :default-val="form.dbfsc"
                  :is-multipule-select="true"
                  :cus-style="'width: 300px; margin-right: 10px; display:inline-block'"
                  @change="changeGuaranty"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="信贷类型" prop="dklxc">
                <select-from-dictionary
                  :code="'loan'"
                  :placeholder="'信贷类型'"
                  :default-val="form.dklxc"
                  :cus-style="'width: 300px; margin-right: 10px; display:inline-block'"
                  @change="changeLoan"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="发布时间" prop="publishTime">
                <el-date-picker
                  v-model="form.publishTime"
                  type="datetime"
                  placeholder="请选择发布时间"
                  value-format="timestamp"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户经理" prop="khjl">
                  <el-input
                      v-model="form.khjl"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                  />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="lxrdh" >
                <el-input
                    v-model="form.lxrdh"
                    clearable
                    placeholder="请输入"
                    show-word-limit
                    maxlength="11"
                />
            </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="产品描述" prop="cpms">
                <!-- <el-input
                    v-model="form.cpms"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    clearable
                    maxlength="300"
                    show-word-limit
                /> -->
                <editor
                  ref="editor"
                  @change="changeEditor"
                  v-model="form.cpms"
                ></editor>
            </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFiles } from '@/api/index'
import { validateForm ,validateCellPhone } from '@/utils'
import uEditor from "@/components/uEditor/index";
import {addProduct ,editProduct } from "@/views/financInstitutionPC/viewApi";

export default {
  name: 'Dialog',
  components: { editor: uEditor },
  props: ['showDialog', 'dialogTitle', 'viewData'],
  data () {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      form:{
        cpmc:'',
        images:'',

        dked:'',
        dkedxx:'',
        dkedsx:'',

        llfw:'',
        zdnhlv:'',
        zgnhlv:'',

        dkqx:'',
        dkqxxx:'',
        dkqxsx:'',

        dbfsc:'',
        dbfsm:'',

        dklxc:'',
        dklxm:'',

        khjl:'',
        lxrdh:'',
        cpms:'',
        publishTime: null,
      },
      rules: {
        cpmc: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        images: [
            { required: true, message: '请上传图标', trigger: ['blur', 'change'] }
        ],
        dkedsx: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        zgnhlv: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        dkqxsx: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        dbfsc: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        dklxc: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        khjl: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        lxrdh: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
          { validator: validateCellPhone, trigger: ["blur", "change"] },
        ],
        cpms: [
            { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ]
      },
    }
  },
  created () {
    if (this.viewData&&this.viewData.id) {
      this.form = {image: this.viewData.path , ...this.viewData};
      // 担保方式多选回显：将逗号分隔字符串转为数组
      if (this.form.dbfsc && typeof this.form.dbfsc === 'string') {
        this.form.dbfsc = this.form.dbfsc.split(',');
      }
    }
  },
  mounted() {

  },
  methods: {
    changeGuaranty(data){
      // 多选时 data 包含 nameList 和 codeList
      if (data.codeList) {
        this.form.dbfsc = data.codeList.join(',');
        this.form.dbfsm = data.nameList.map(item => item.dictionaryKey).join(',');
      } else {
        // 兼容单选情况
        this.form.dbfsc = data.code;
        this.form.dbfsm = data.dictionaryKey;
      }
    },
    changeLoan(data){
      this.form.dklxc = data.code;
      this.form.dklxm = data.dictionaryKey;
    },

    changeEditor (value) {
      this.form.cpms = value;
    },

    //上传
    uploadedFiles (file) {
        let formData = new FormData();
        formData.append('file', file)
        uploadFiles(formData).then(( res )=>{
          if(res.data){
            this.form.images = res.data.url;
          }
        })
    },
    handleAvatarSuccess(res, file) {
    },

    // 提交
    async submit () {
      if (!validateForm(this.$refs["form"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      let res = {}
      let message = ''
      if (this.viewData&&this.viewData.id) {
        this.form.id = this.viewData.id;
        res = await editProduct(this.form)
        message = '修改成功。'
      } else {
        res = await addProduct(this.form)
        message = '新增成功。'
      }
      this.$baseMessage(message, 'success')
      this.$emit('closeDialog', true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    }

  }
}
</script>
<style >
.dialog-footer{
  width: 160px !important;
  height: 50px !important;
  margin: auto !important;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
